/**
 * Map name for mutations
 * @types {string}
 */

export const SET_HIERARCHY = "HIERARCHY/SET_HIERARCHY";
